import MokhaberatIcon from "../../images/mokhaberat.png";
import GasIcon from "../../images/gas.png";
import WaterIcon from "../../images/water.png";
import ElectIcon from "../../images/elect.png";
import MobileIcon from "../../images/mobile.png";
import {
    waterIdSchema,
    electricityIdSchema,
    telSchema,
    gasIdSchema,
    mobileSchema,
} from "../Validations";

const BillTypes = {
    "TelBills": {
        receipt_title :'قبض تلفن',
        inputName: 'tel',
        inputLabel: 'شماره تلفن',
        inputPlaceHolder: 'شماره تلفن را وارد کنید',
        icon: MokhaberatIcon,
        title: "تلفن",
        validation: telSchema,
        defaultValue: {
            tel: '',
            label: ''
        }
    },
    "Tel": {
        receipt_title :'قبض تلفن (میان دوره)',
        inputName: 'tel',
        inputLabel: 'شماره تلفن',
        inputPlaceHolder: 'شماره تلفن را وارد کنید',
        icon: MokhaberatIcon,
        title: "تلفن",
        validation: telSchema,
        defaultValue: {
            tel: '',
            label: ''
        }
    },
    "TelNow": {
        receipt_title :'قبض تلفن (پایان دوره)',
        inputName: 'tel',
        inputLabel: 'شماره تلفن',
        inputPlaceHolder: 'شماره تلفن را وارد کنید',
        icon: MokhaberatIcon,
        title: "تلفن",
        validation: telSchema,
        defaultValue: {
            tel: '',
            label: ''
        }
    },
    "Mobile": {
        receipt_title :'قبض موبایل (پایان دوره)',
        inputName: 'mobile',
        inputLabel: 'شماره همراه  ',
        inputPlaceHolder: 'شماره همراه را وارد کنید',
        icon: MobileIcon,
        title: "تلفن همراه",
        validation: mobileSchema,
        defaultValue: {
            mobile: '',
            label: ''
        }
    },
    "MobileNow": {
        receipt_title :'قبض موبایل (میان دوره)',
        inputName: 'mobile',
        inputLabel: 'شماره همراه  ',
        inputPlaceHolder: 'شماره همراه را وارد کنید',
        icon: MobileIcon,
        title: "تلفن همراه",
        validation: mobileSchema,
        defaultValue: {
            mobile: '',
            label: ''
        }
    },
    "GasByBillId": {
        receipt_title :'قبض گاز',
        inputName: 'gas',
        inputLabel: 'شناسه قبض',
        inputPlaceHolder: 'شناسه قبض را وارد کنید',
        icon: GasIcon,
        title: "گاز",
        validation: gasIdSchema,
        defaultValue: {
            gas: '',
            label: ''
        }
    },
    "Water": {
        receipt_title :'قبض آب',
        inputName: 'water',
        inputLabel: 'شناسه قبض',
        inputPlaceHolder: 'شناسه قبض را وارد کنید',
        icon: WaterIcon,
        title: "آب",
        validation: waterIdSchema,
        defaultValue: {
            water: '',
            label: ''
        }
    },
    "Electricity": {
        receipt_title :'قبض برق',
        inputName: 'electricity',
        inputLabel: 'شناسه قبض',
        inputPlaceHolder: 'شناسه قبض را وارد کنید',
        icon: ElectIcon,
        title: "برق",
        validation: electricityIdSchema,
        defaultValue: {
            electricity: '',
            label: ''
        }
    },
    "MobileBills": {
        receipt_title :'قبض موبایل',
        inputName: 'mobile',
        inputLabel: 'شماره همراه  ',
        inputPlaceHolder: 'شماره همراه را وارد کنید',
        icon: MobileIcon,
        title: "تلفن همراه",
        validation: mobileSchema,
        defaultValue: {
            mobile: '',
            label: ''
        }
    }
}
export default BillTypes;